import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-become-a-partner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './become-a-partner.html',
  styleUrl: './become-a-partner.css',
})
export class BecomeAPartnerComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Become a Partner',
      description: 'Join the orderYaa partner network to implement, resell, and support our ERP & POS platform.',
      path: '/become-a-partner',
    });
  }
}
